import { RuntimeColumnDescriptor } from "@vuu-ui/vuu-table-types";
import { getColumnStyle, isDataValueEditable } from "@vuu-ui/vuu-utils";
import cx from "clsx";
import { useMemo } from "react";

export const useCell = (
  column: RuntimeColumnDescriptor,
  classBase: string,
  isHeader?: boolean,
) =>
  // TODO measure perf without the memo, might not be worth the cost
  useMemo(() => {
    const className = cx(classBase, column.className, {
      vuuPinLeft: column.pin === "left",
      vuuPinRight: column.pin === "right",
      vuuEndPin: isHeader && column.pinnedWidth,
      [`${classBase}-editable`]: isDataValueEditable(column, "update"),
      [`${classBase}-right`]: column.align === "right",
    });

    const style = getColumnStyle(column);
    return {
      className,
      style,
    };
  }, [classBase, column, isHeader]);
